import React, { useState, useEffect } from "react";
import _ from "lodash";

import { useServerApi } from "../hooks/userServerApi";
import { SimpleGrid, NumberInput, TextInput } from "@mantine/core";
import { useFormRender } from "../hooks/useFormRender";
import { ENUM_FORM_DISPLAY, ENUM_FORM_LAYOUT_CONTAINER } from "./pageList";
import {
  DATA_CURRENCY,
  DATA_AGE_TYPES,
  DATA_PAY_MODES,
  DATA_PAY_STATUS,
  DATA_PAYMENT_METHOD,
} from "../data/options";
import { Select, MultiSelect } from "@mantine/core";
import ReactJson from "react-json-view";
import { useFormatter } from "../hooks/useFomatter";
import { DatePicker } from "@mantine/dates";

const isCreditCardPayBy = (payBy) => {
  if (!payBy) return false;
  if (Array.isArray(payBy)) return payBy.includes("Credit Card");
  return payBy === "Credit Card";
};

const OrderPaymentDetailForm = ({ form: mainForm }) => {
  const [formatter] = useFormatter();
  const forceUncertainPayment = _.get(
    mainForm?.values,
    "forceUncertainPayment"
  );
  // Product Limitation
  // const [payTermMax, setPayTermMax] = useState(100);
  // const [payTermMin, setPayTermMin] = useState(1);

  // const payment = _.get(mainForm.values, "payment");
  // const product = _.get(mainForm.values, "productSnapShot");

  const {
    payTermMax,
    payTermMin,
    payment,
    productSnapShot: product, //? need snapshot anymore?
  } = mainForm.values;

  const initData = () => {
    if (!product) return;
  };

  const onSubmit = ({ values, formMode }) => {
    console.log(values);
    // mainForm.setValues(values)
    // mainForm.saveValues(values)
  };

  const formSchema = {
    display: {
      mode: ENUM_FORM_DISPLAY.INSIDE,
      size: "xl", //xs, sm, xl  ....100%
    },

    initialValues: {},

    validate: {
      // paymentTerm: (value) =>
      // 	value < payTermMin
      // 		? `Payment Term must be larger or equal to ${payTermMin}`
      // 		: value > payTermMax
      // 		? `Payment Term must be lesser or equal to ${payTermMax}`
      // 		: null,
      // paymentTerm: (value) => (value > payTermMax ? `Payment Term must be lesser or equal to ${payTermMax}` : null),
    },

    showSaveBar: true,

    layout: {
      containers: [
        {
          key: "section-payment",
          parent: null,
          type: ENUM_FORM_LAYOUT_CONTAINER.GRID,
          cols: [
            {
              key: "paymentInfo-g1",
              props: {
                span: 6,
              },
            },
            {
              key: "paymentInfo-g2",
              props: {
                span: 6,
              },
            },
          ],
        },
      ],

      fields: [
        {
          name: "premium",
          component: NumberInput,
          parent: "paymentInfo-g1",
          props: {
            required: true,
            label: "Premium",
            precision: 2,
            parser: formatter.currencyParser,
            formatter: formatter.currencyFormat,
          },
        },
        {
          name: "payMode",
          component: Select,
          parent: "paymentInfo-g1",
          props: {
            required: true,
            label: "Pay Mode",
            placeholder: "",
            data: DATA_PAY_MODES,
            multiple: true,
            searchable: true,
            clearable: true,
            // dropdownPosition:"top",
          },
        },
        {
          name: "payStatus",
          component: Select,
          parent: "paymentInfo-g1",
          props: {
            label: "Pay Status",
            placeholder: "",
            data: DATA_PAY_STATUS,
            searchable: true,
            clearable: true,
          },
        },

        {
          name: "paymentTerm",
          component: NumberInput,
          parent: "paymentInfo-g1",
          props: {
            label: "Payment Term (Yrs)",
          },
        },
        {
          name: "paymentTermUntilAge",
          component: NumberInput,
          parent: "paymentInfo-g1",
          props: {
            label: "Payment Term (Until Age)",
          },
        },
        {
          name: "policyTerm",
          component: NumberInput,
          parent: "paymentInfo-g1",
          props: {
            label: "Policy Term",
          },
        },

        {
          name: "currency",
          component: Select,
          parent: "paymentInfo-g2",
          props: {
            required: true,
            label: "Currency",
            placeholder: "",
            searchable: true,
            data: DATA_CURRENCY,
            default: "HKD",
          },
        },

        {
          name: "levy",
          component: NumberInput,
          parent: "paymentInfo-g2",
          props: {
            required: true,
            label: "Levy",
            precision: 2,
            parser: formatter.currencyParser,
            formatter: formatter.currencyFormat,
          },
        },

        {
          name: "payBy",
          component: Select,
          parent: "paymentInfo-g2",
          props: {
            label: "Inital Payment Methods",
            placeholder: "",
            required: true,

            data: DATA_PAYMENT_METHOD,
            multiple: true,
            searchable: true,
            clearable: true,
            // dropdownPosition:"top",
          },
        },

        {
          name: "creditCardLast4",
          component: TextInput,
          parent: "paymentInfo-g2",
          visibleOnly: (values) => isCreditCardPayBy(values?.payBy),
          props: {
            label: "Credit Card (Last 4 Digits)",
            placeholder: "1234",
            maxLength: 4,
          },
        },

        {
          name: "initialPaymentCurrency",
          component: Select,
          parent: "paymentInfo-g2",
          props: {
            required: true,
            label: "Initial Payment Currency",
            placeholder: "",
            searchable: true,
            data: DATA_CURRENCY,
            default: "HKD",
          },
        },

        {
          name: "initialPayment",
          component: NumberInput,
          parent: "paymentInfo-g2",
          props: {
            label: "Initial Payment",

            precision: 2,
            parser: formatter.currencyParser,
            formatter: formatter.currencyFormat,
          },
        },

        {
          name: "renewalPayBy",
          component: Select,
          parent: "paymentInfo-g2",
          props: {
            label: "Renewal Payment Methods",
            placeholder: "",

            data: DATA_PAYMENT_METHOD,
            multiple: true,
            searchable: true,
            clearable: true,
            // dropdownPosition:"top",
          },
        },
        {
          name: "sumInsured",
          component: NumberInput,
          parent: "paymentInfo-g1",
          props: {
            label: "Sum Insured",
            precision: 2,
            parser: formatter.currencyParser,
            formatter: formatter.currencyFormat,
          },
        },
        {
          name: "preliminaryDate",
          component: DatePicker,
          parent: "paymentInfo-g2",
          type: "datePicker",
          props: {
            label: "Preliminary Date",
            required: false,
            clearable: true,
            zIndex: 1000,
            allowFreeInput: true,
          },
        },
        {
          name: "prePaymentCurrency",
          component: Select,
          parent: "paymentInfo-g1",
          props: {
            label: "Pre Payment Currency",
            placeholder: "",
            searchable: true,
            data: DATA_CURRENCY,
            default: "HKD",
          },
        },
        {
          name: "prePayment",
          component: NumberInput,
          parent: "paymentInfo-g2",
          props: {
            label: "Pre Payment",
            defaultValue: 0,
            precision: 2,
            parser: formatter.currencyParser,
            formatter: formatter.currencyFormat,
          },
        },

        // {
        //   name: "initialPayment",
        //   component: NumberInput,
        //   parent: "paymentInfo-g2",
        //   props: {
        //     required: true,
        //     label: "Initial Payment",
        //     precision: 2,

        //     parser: formatter.currencyParser,
        //     formatter: formatter.currency,
        //   },
        // },
      ],
    },
  };

  const onChange = (values) => {
    const next = { ...values };
    const payCount = getPayCount(next);
    if (Number.isFinite(payCount)) {
      next.payCount = payCount;
    }
    if (!next.initialPaymentCurrency) {
      next.initialPaymentCurrency = "HKD";
    }
    if (!next.payStatus) {
      next.payStatus = "ACTIVE";
    }
    // Merge so unfilled fields (e.g. maturityDate, payUpDate) are not dropped
    mainForm.setFieldValue("payment", {
      ...(mainForm.values?.payment || {}),
      ...next,
    });
  };

  const getPayCount = ({ payMode, paymentTerm }) => {
    if (payMode === "LUMPSUM") return 1;
    if (paymentTerm == null || paymentTerm === "") return undefined;
    const term = Number(paymentTerm);
    if (!Number.isFinite(term)) return undefined;
    switch (payMode) {
      case "MONTHLY":
        return 12 * term;
      case "QUARTERLY":
        return 4 * term;
      case "SEMIANNUALLY":
        return 2 * term;
      case "ANNUALLY":
        return term;
      default:
        return undefined;
    }
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    null,
    onSubmit,
    onChange
  );

  useEffect(() => {
    initData();
    formAction.open({
      mode: "edit",
      data: {
        initialPaymentCurrency: "HKD",
        ...payment,
        payStatus: payment?.payStatus || "ACTIVE",
      },
    });
  }, [product?._id]);

  return (
    <>
      {/* productId:{productId} */}
      {/* <ReactJson
                src={mainForm.values.payment}
                style={{ background: "white" }}
                collapsed={true}
            /> */}
      {/* <ReactJson  src={product} style={{background:"white"}} collapsed={true}/> */}

      {!forceUncertainPayment && renderForm()}
    </>
  );
};

export default OrderPaymentDetailForm;
